import CalendarEventItem from 'src/components/Items/CalendarEventItem';
import moment from '../../../utils/moment';
import React from 'react';
import theme from '../../../ui/theme';
import useStyles from './style';
import { compareDates } from 'src/utils/date';
import { getElementID } from 'src/utils/useUUID';
import { Popover } from '@mui/material';
import { useEffect } from 'src/utils/useEffect';
import { useState } from 'src/utils/useState';
import { useTranslation } from 'react-i18next';
import { weekdays } from 'src/constants/weekdays';

type CalendarEventsItemType = {
  id?: any;
  anchorEl: any;
  onClose: any;
  date: any;
  events: any;
};

const CalendarEventsItem: React.FunctionComponent<CalendarEventsItemType> = ({id = getElementID(), anchorEl, onClose, date = moment(), events = []}) => {

  const classes = useStyles();
  const { t } = useTranslation();

  const [isVisible, setIsVisible] = useState(Boolean(anchorEl));

  useEffect(() => {
    if(Boolean(anchorEl)) {
      setIsVisible(true);
    }
  }, [anchorEl])

  const handleOnClose = () => {
    onClose();
    setTimeout(() => {
      setIsVisible(false);
    }, theme.transitions.duration.complex);
  };

  return isVisible ? (
    <Popover className={classes.popover} id={id} open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={handleOnClose} anchorOrigin={{ vertical: 'center', horizontal: 'center' }} transformOrigin={{ vertical: 'center', horizontal: 'center' }}>
      <p className={`${classes.date} ${events.length === 0 ? 'empty' : null}`}>
        {t(weekdays[moment(date).isoWeekday() - 1].toLowerCase())}
        <span className={compareDates(date, moment()) ? classes.today : ''}>{date.date()}</span>
      </p>
      <div className={classes.list}>
        {
          events.map((item: any, key: any) => (
            <CalendarEventItem data={item} date={date} overlaping={false} key={`k_${key}`}/>
          ))
        }
        {
          events.length === 0 ? (
            <span>{t('calendar_no_event_this_day')}</span>
          ) : null
        }
      </div>
    </Popover>
  ) : null;
};

export default CalendarEventsItem;